export const getMaxOrderId = (deals = [], standaloneProducts = []) => {
  const orderIds = [
    ...deals.map(deal => deal.order_deals.flatMap(order => order.order_id)),
    ...standaloneProducts.map(product =>
      product.order_products.flatMap(order => order.order_id)
    )
  ].flat();

  return Math.max(...orderIds);
};

export const getIntercomAppId = () =>
  window.icApiId || import.meta.env.VITE_INTERCOM_APP_ID || '';

// const INTERCOM_SAFARI_LISTENER_FLAG = '__bwIntercomSafariCloseListeners';
//
// /** Stock iOS Safari (excludes iOS Chrome/Firefox/Edge, which use different browser chrome). */
// export const isIosMobileSafari = () => {
//   if (typeof navigator === 'undefined') return false;
//   const ua = navigator.userAgent || '';
//   if (!/(iPhone|iPad|iPod)/i.test(ua)) return false;
//   if (/\b(CriOS|FxiOS|EdgiOS|OPiOS)\b/.test(ua)) return false;
//   return /\bSafari\b/i.test(ua) && /\bAppleWebKit\b/i.test(ua);
// };
//
// function attachIntercomSafariCloseListenersOnce() {
//   if (typeof window === 'undefined') return;
//   if (!isIosMobileSafari()) return;
//   if (window[INTERCOM_SAFARI_LISTENER_FLAG]) return;
//   if (typeof window.Intercom !== 'function') return;
//
//   window.Intercom('onShow', () => {
//     window.dispatchEvent(new CustomEvent('bw-intercom-show'));
//   });
//   window.Intercom('onHide', () => {
//     window.dispatchEvent(new CustomEvent('bw-intercom-hide'));
//   });
//   window[INTERCOM_SAFARI_LISTENER_FLAG] = true;
// }

export const isIntercomAvailable = () => {
  const appId = getIntercomAppId();
  return Boolean(appId && typeof window.loadIcWidget === 'function');
};

export const initializeIntercom = ({
  partnerUser,
  partner,
  deals,
  standaloneProducts
}) => {
  const appId = getIntercomAppId();
  if (!appId || typeof window.loadIcWidget !== 'function') return;

  const orderId = getMaxOrderId(deals, standaloneProducts);
  const partnerId = partner?.id;
  const orderUrl = window.appUrl
    ? `${window.appUrl}/admin/${partnerId}/order/${orderId}`
    : undefined;
  const envPrefix =
    window.enviroment !== 'production' ? `${window.enviroment}-` : '';

  window.intercomSettings = {
    api_base: 'https://api-iam.intercom.io',
    app_id: appId,
    user_id: `${envPrefix}PH-${partnerUser.id}`,
    name: partnerUser.name,
    email: partnerUser.email,
    Role: 'Passholder',
    order_url: orderUrl,
    order_partnerName: partner?.name,
    order_partnerID: partnerId,
    phone: partnerUser.phone || undefined,
    hide_default_launcher: true
  };

  window.loadIcWidget(appId);
  // attachIntercomSafariCloseListenersOnce();
};

export const openIntercom = () => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('showNewMessage');
  }
};
